module.exports = __webpack_public_path__ + "img/winerackdog07.a4ababc8.jpg";